import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { InformationCircleIcon } from '@heroicons/react/24/outline'
import { usePlatformNotice, useNoticeText } from './usePlatformNotice'
import { SupportEmailText } from './SupportEmailText'

/**
 * #2072 — top banner shown to every user type on every page while a platform
 * notice is active, including after the user confirmed the entry modal. It has
 * no dismiss control: it disappears only when an admin turns the notice off.
 */
export const PlatformNoticeBanner: FC = () => {
  const { t } = useTranslation('common')
  const { data } = usePlatformNotice()
  const text = useNoticeText(data?.notice)

  if (!data?.notice) return null

  return (
    <div
      role="status"
      aria-label={t('platformNotice.bannerLabel')}
      data-testid="platform-notice-banner"
      className="bg-amber-50 border-b-2 border-amber-300 px-4 py-2.5 text-amber-900"
    >
      <div className="container mx-auto flex items-center justify-center gap-3 text-center">
        <InformationCircleIcon className="h-5 w-5 flex-shrink-0 text-amber-600" aria-hidden="true" />
        <span className="text-sm font-medium">
          <SupportEmailText text={text('banner')} linkClassName="font-bold underline text-amber-800 hover:text-amber-950" />
        </span>
      </div>
    </div>
  )
}
